"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _UploadMaterail = _interopRequireDefault(require("@/components/UploadMaterail/UploadMaterail.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
var _material = require("@/api/material/material");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "name",
        placeholder: "关键字"
      }],
      majorDialog: false,
      modelData: {
        name: "",
        status: ""
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "200"
      }, {
        name: "项目类型名称",
        prop: "matchTypeName",
        isShow: true,
        width: "200"
      }
      // {
      //   name: "作品数",
      //   prop: "worksCount",
      //   isShow: true,
      //   width: "100"
      // }
      ],
      funBtns: [],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: "",
      materialNameList: [],
      materialList: [],
      name: ""
    };
  },
  methods: {
    TypeChange: function TypeChange(val) {
      console.log(val);
    },
    //获取报名表列表
    registrationList: function registrationList(e) {
      console.log("报名表列表数据", e);
      this.$router.push({
        path: "/education/registrationList",
        query: {
          id: e.id
        }
      });
    },
    // 查看作品清单列表
    viewWorksList: function viewWorksList(e) {
      this.$router.push({
        path: "/education/worksCatalogue",
        query: {
          id: e.id
        }
      });
    },
    // 获取学校下项目列表
    getSchoolProjectList: function getSchoolProjectList() {
      var _this = this;
      (0, _school.schoolProject)(_objectSpread({
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }, this.modelData)).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    // 查看项目阶段
    viewStage: function viewStage(e) {
      this.$router.push({
        path: "/education/viewProjectStage",
        query: {
          id: e.id
        }
      });
    },
    // 点击确定按钮
    majorUpdata: function majorUpdata() {
      var _this2 = this;
      (0, _material.insertMatchMaterial)({
        matchId: this.matchId,
        materialList: this.materialList
      }).then(function () {
        _this2.$message.success("操作成功！");
      });
      this.majorDialog = false;
    },
    successData: function successData(e, index) {
      if (e.code === 1) {
        var fileSetId = this.materialList[index].id;
        this.$set(this.materialList, index, {
          url: e.ossOriUrl,
          uploadFileShow: false,
          materialName: e.fileName,
          id: fileSetId
        });
      } else {
        this.$message.error("上传失败");
      }
    },
    del: function del(i) {
      this.materialList[i].fileName = "";
      this.materialList[i].uploadFileShow = true;
    },
    // 点击上传申报材料操作按钮
    uploadMajor: function uploadMajor(row) {
      var _this3 = this;
      (0, _material.getFileUrlForSchool)({
        matchId: row.id
      }).then(function (res) {
        _this3.majorDialog = true;
        _this3.matchId = row.id;
        _this3.materialNameList = res.data;
        _this3.materialList = [];
        for (var k in _this3.materialNameList) {
          _this3.materialList.push({
            url: _this3.materialNameList[k].url,
            materialName: _this3.materialNameList[k].materialName,
            uploadFileShow: true,
            id: _this3.materialNameList[k].id
          });
        }
      });
    },
    listBureau: function listBureau(e) {
      this.getSchoolProjectList();
    },
    dels: function dels() {},
    // 新增
    save: function save() {},
    edit: function edit() {},
    handleSelectionChange: function handleSelectionChange() {},
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getSchoolProjectList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getSchoolProjectList();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default,
    UploadMaterail: _UploadMaterail.default
  },
  created: function created() {
    this.getSchoolProjectList();
    if (this.prCode == "guizhou") {
      this.defaultColumn = [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "200"
      }, {
        name: "项目类型名称",
        prop: "matchTypeName",
        isShow: true,
        width: "200"
      }, {
        name: "专业大类",
        prop: "majorName",
        isShow: true,
        width: "100"
      }, {
        name: "报名人数",
        prop: "partyCount",
        isShow: true,
        width: "100"
      }];
      this.queryGroup = [{
        label: "精确查找",
        type: "input",
        model: "name",
        placeholder: "关键字"
      }, {
        label: "报名状态",
        type: "select",
        model: "status",
        options: [{
          name: "未报名",
          value: 1
        }, {
          name: "已报名",
          value: 2
        }],
        placeholder: "报名状态"
      }];
    }
  }
};